const ShowMoreLink = ({ href, text = "Visa mer" }) => {
  return (
    <a
      href={href}
      className="group flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-stone-400 hover:text-white transition-colors py-2"
    >
      <span>{text}</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="text-[#0047ff] w-4 h-4 transition-transform group-hover:translate-x-1"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={3}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
      </svg>
    </a>
  );
};

export default ShowMoreLink;
